import { GlButton, GlModalDirective } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import UploadBlobModal from '../../repository/components/upload_blob_modal.vue?vue3';
const UPLOAD_BLOB_MODAL_ID = 'details-modal-upload-blob';
export default {
    name: 'UploadButton',
    components: {
        GlButton,
        UploadBlobModal
    },
    directives: {
        GlModal: GlModalDirective
    },
    inject: {
        targetBranch: {
            default: ''
        },
        originalBranch: {
            default: ''
        },
        canPushCode: {
            default: false
        },
        canPushToBranch: {
            default: false
        },
        path: {
            default: ''
        },
        emptyRepo: {
            default: false
        }
    },
    uploadBlobModalId: UPLOAD_BLOB_MODAL_ID
};
